import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { getEmployeeCrew } from "../../../../services/RHService/CrewService";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
const EmployeeCrew = () => {
  //variables
  const [employee, setEmployee] = useState({});

  const fetchData = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.token.idUser;
    const response = await getEmployeeCrew(userId);
    setEmployee(response.success);
  };

  useEffect(() => {
    fetchData();
  }, []);

  //colonnes de tableau
  const columns = [
    { dataField: "id", text: "#" },
    { dataField: "nomprenom", text: "Personnel" },
    { dataField: "mobile", text: "Mobile" },
    { dataField: "email", text: "Email" },
  ];
  //data de table

  const tableData = employee.collegues
    ? employee.collegues.map((collegue, index) => {
        return {
          id: index + 1,
          nomprenom: collegue.firstname + " " + collegue.lastname,
          mobile: collegue.phone,
          email: collegue.email,
        };
      })
    : [];

  return (
    <div class="content-wrapper" style={{ marginTop: "0" }}>
      <ToolkitProvider keyField="id" data={tableData} columns={columns}>
        {(props) => (
          <div>
            {/* header */}
            <div className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <h1 className="m-0">Votre équipe et vos collègues</h1>
                  </div>
                  <div className="col-sm-6">
                    <ol className="breadcrumb float-sm-right">
                      <li className="breadcrumb-item">
                        <i class="fa-solid fa-house"></i>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/employee">Home</Link>
                      </li>
                      <li className="breadcrumb-item active">Mon équipe</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            {/* body */}
            <div class="container-fluid">
              <div class="row">
                {employee.idEquipe ? (
                  <>
                    <div class="col-md-12">
                      <div class="card">
                        <div class="card-body">
                          <div class="row">
                            <div className="col-md-3">
                              <strong className="center">Votre équipe</strong>
                              <br></br>
                              {employee ? employee.nomEquipe : ""}
                            </div>
                            <div className="col-md-3">
                              <strong className="center">Chef d'équipe</strong>
                              <br></br>
                              {employee
                                ? employee.chefEquipeFirstName
                                : ""}{" "}
                              {employee ? employee.chefEquipeLastName : ""}{" "}
                            </div>

                            <div className="col-md-3">
                              <strong className="center">Email</strong>
                              <br></br>
                              {employee ? employee.chefEquipEmail : ""}{" "}
                            </div>
                            <div className="col-md-3">
                              <strong className="center"> Département</strong>
                              <br></br>
                              {employee ? employee.nomDept : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="card">
                        <div className="card-header">
                          <div className="card-title">Horaire</div>
                        </div>
                        <div class="card-body">
                          <div class="row">
                            <div className="col-md-3">
                              <strong className="center">Date Début</strong>
                              <br></br>
                              {employee
                                ? new Date(
                                    employee.dateDeb
                                  ).toLocaleDateString()
                                : ""}
                            </div>
                            <div className="col-md-3">
                              <strong className="center">Date Fin</strong>
                              <br></br>
                              {employee
                                ? new Date(
                                    employee.dateFin
                                  ).toLocaleDateString()
                                : ""}
                            </div>

                            <div className="col-md-3">
                              <strong className="center">Heure Début</strong>
                              <br></br>
                              {employee ? employee.heureDeb : ""}{" "}
                            </div>
                            <div className="col-md-3">
                              <strong className="center">Heure Fin</strong>
                              <br></br>
                              {employee ? employee.heureFin : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="card">
                        <div class="card-body">
                          {/* table */}
                          <BootstrapTable
                            {...props.baseProps}
                            data={tableData}
                            columns={columns}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="col-md-12">
                    <div className="card text-center">
                      <div className="card-body d-flex align-items-center justify-content-center">
                        <p>Vous n'avez pas encore été assigné à une équipe.</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default EmployeeCrew;
